import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { faqs } from '../data/kit';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="px-4 py-12 bg-cream-100 border-t border-cream-300" data-id="element-73" data-mp="1hdbftsfyjr8d">
      <div className="max-w-3xl mx-auto" data-id="element-74" data-mp="1hbgpfylx36ww">
        <h2 className="font-serif text-2xl md:text-3xl font-bold text-wine text-center mb-7" data-id="element-75" data-mp="1cf9l2a9663h2">
          ❓ PREGUNTAS FRECUENTES
        </h2>
        <div className="space-y-3" data-id="element-76" data-mp="2a1gzebv9za6m">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="border border-cream-300 rounded-xl bg-white overflow-hidden" data-id="element-77" data-mp="2042n8ogdx7k4" data-mpi={i}>
                <button className="w-full px-5 sm:px-6 py-4 text-left flex justify-between items-center gap-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-rose-500 rounded-xl" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} data-id="element-78" data-mp="1v5823fuy36wu">
                  <span className="font-bold text-wine uppercase text-sm sm:text-[15px] leading-snug" data-id="element-79" data-mp="1klvwm0dynjwr">
                    {faq.q}
                  </span>
                  {isOpen ? <Minus className="w-5 h-5 text-rose-600 shrink-0" data-id="element-80" data-mp="1apanb2uwrmn4" /> : <Plus className="w-5 h-5 text-ink-soft shrink-0" data-id="element-81" data-mp="1fmssci5t1hpu" />}
                </button>
                {isOpen && <div id={`faq-${i}`} className="px-5 sm:px-6 pb-4 text-ink-muted leading-relaxed" data-id="element-82" data-mp="16oh3oloi0u01">
                    {faq.a}
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}